/** Backend may wrap payload in `data` (e.g. `{ status, message, data }` or `{ success, data }`). */
export function unwrapApiBody<T>(body: unknown): T {
  if (body && typeof body === 'object' && 'data' in body) {
    const o = body as { data?: T };
    if (o.data !== undefined) return o.data;
  }
  return body as T;
}
